import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import {
  Button,
  Grid,
  Hidden,
  IconButton,
  useTheme,
  TextField,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { logout } from "../redux/authSlice";
import { useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Modal from "./Modal";
import { getPosts } from "../redux/postSlice";
import { addPost } from "../api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useForm } from "react-hook-form";
import { nanoid } from "nanoid";

export default function LeftSidebar() {
  const theme = useTheme();

  const dispatch = useDispatch();
  const { _id } = JSON.parse(localStorage.getItem("login"));
  const [data, setData] = useState([]);
  const [postList, setDontPost] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [inputError, setInputError] = useState("");

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleAddPost = async () => {
    if (postList) {
      const data1 = await addPost({ text: data });
      if (data1) {
        dispatch(getPosts());
        setData([]);
        setDontPost(false);
      }
    }
  };

  const deleteItem = (id) => {
    setData(data.filter((x) => x.id !== id));
  };
  const handleEnd = (result) => {
    console.log(result);
    if (!result.destination) return; //if no destination exits(cancel event), exit this function
    const items = Array.from(data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setData(items);
  };
  const { register, handleSubmit } = useForm();

  const onSubmit = (input) => {
    const id = nanoid();
    if (input.name !== "" && input.name.length >= 5) {
      setDontPost(true);
      setInputError("");
      setData([...data, { id, name: input.name }]);
    } else {
      setInputError("List items should atleast have 5 character");
      setDontPost(false);
    }
  };

  return (
    <>
      <Box sx={{ height: "100vh", width: "100%", pt: 1 }}>
        <Box textAlign="center">
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
              backgroundColor: "inherit",
            }}
          >
            <img src="/logo.png" alt="logo" width="50px" />
          </Link>
        </Box>
        <List>
          <NavLink
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
              backgroundColor: "inherit",
            }}
          >
            <ListItem
              button
              sx={{
                borderRadius: "28px",
                margin: ".5rem 0",
              }}
            >
              <ListItemIcon>
                <HomeIcon fontSize="medium" color="action" />
              </ListItemIcon>
              <Hidden lgDown>
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: "18px",
                    color: theme.palette.action.active,
                  }}
                  primary="Home"
                />
              </Hidden>
            </ListItem>
          </NavLink>
          <ListItem
            button
            sx={{
              borderRadius: "28px",
              margin: ".5rem 0",
            }}
          >
            <ListItemIcon>
              <BookmarkIcon fontSize="medium" color="action" />
            </ListItemIcon>
            <Hidden lgDown>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: "18px",
                  color: theme.palette.action.active,
                }}
                primary="Bookmarks"
              />
            </Hidden>
          </ListItem>
          <ListItem
            button
            sx={{
              borderRadius: "28px",
              margin: ".5rem 0",
            }}
          >
            <ListItemIcon>
              <FavoriteIcon fontSize="medium" color="action" />
            </ListItemIcon>
            <Hidden lgDown>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: "18px",
                  color: theme.palette.action.active,
                }}
                primary="Likes"
              />
            </Hidden>
          </ListItem>
          <NavLink
            to={`/profile/${_id}`}
            style={{
              textDecoration: "none",
              color: "inherit",
              backgroundColor: "inherit",
            }}
          >
            <ListItem
              button
              sx={{
                borderRadius: "28px",
                margin: ".5rem 0",
              }}
            >
              <ListItemIcon>
                <PersonOutlineIcon fontSize="medium" color="action" />
              </ListItemIcon>
              <Hidden lgDown>
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: "18px",
                    color: theme.palette.action.active,
                  }}
                  primary="Profile"
                />
              </Hidden>
            </ListItem>
          </NavLink>
          <ListItem
            id="basic-button"
            button
            sx={{
              borderRadius: "28px",
              margin: ".5rem 0",
            }}
            onClick={() => {
              dispatch(logout());
            }}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="medium" color="action" />
            </ListItemIcon>
            <Hidden lgDown>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: "18px",
                  color: theme.palette.action.active,
                }}
                primary="Logout"
              />
            </Hidden>
          </ListItem>
        </List>
        <Hidden lgDown>
          <Button
            onClick={handleModalOpen}
            variant="contained"
            color="primary"
            fullWidth
            style={{
              borderRadius: "28px",
              padding: "10px",
              textTransform: "capitalize",
            }}
          >
            Post
          </Button>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            onClick={handleModalOpen}
            variant="contained"
            color="primary"
            style={{
              borderRadius: "28px",
              padding: "0 15px",
              textTransform: "capitalize",
              textAlign: "center",
            }}
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Hidden>
      </Box>
      {openModal && (
        <Modal
          open={openModal}
          handleClose={handleModalClose}
          saveText={"Post"}
          handleSave={handleAddPost}
        >
          <Box>
            <Grid container>
              <Grid item flexGrow="1">
                <div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                      error={inputError ? true : false}
                      helperText={inputError}
                      disableUnderline
                      sx={{ width: "70%", pl: "10px" }}
                      placeholder="Post your bucket list"
                      type="text"
                      autoComplete="off"
                      {...register("name")}
                    />

                    <Button sx={{ m: 1 }} component="label">
                      Add
                      <input hidden type="submit" value="Add" />
                    </Button>
                  </form>
                </div>
                <div>
                  <DragDropContext onDragEnd={handleEnd}>
                    <Droppable droppableId="to-dos">
                      {(provided) => (
                        <ul
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {data.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id.toString()}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  {...provided.draggableProps}
                                  ref={provided.innerRef}
                                  {...provided.dragHandleProps}
                                  key={item.id}
                                  className={
                                    snapshot.isDragging
                                      ? "selected"
                                      : "not-selected"
                                  }
                                >
                                  {item.name}
                                  <Button
                                    size="small"
                                    sx={{ ml: "20%" }}
                                    onClick={() => deleteItem(item.id)}
                                  >
                                    Delete
                                  </Button>
                                </li>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </ul>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      )}
    </>
  );
}
